import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import PropertyLabel from "../components/PropertyLabel";
import Box from "../components/Box";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { blockOnlineSale } from "../actions/matrixs";
import { requestProUpgrade, resetProUpgrade } from "../actions/license";

import RemoteActionCustomerSingleAddForm from "../forms/RemoteActionCustomerSingleAddForm";
import RemoteActionFaultAddForm from "../forms/RemoteActionFaultAddForm";
import RemoteActionFaultRepairForm from "../forms/RemoteActionFaultRepairForm";
import RemoteActionBaqueiraRentDaysForm from "../forms/RemoteActionBaqueiraRentDaysForm";
import RemoteActionBaqueiraBlockLockerForm from "../forms/RemoteActionBaqueiraBlockLockerForm";
import RemoteActionBaqueiraClickAndCollectForm from "../forms/RemoteActionBaqueiraClickAndCollectForm";
import RemoteActionBaqueiraWhitelistForm from "../forms/RemoteActionBaqueiraWhitelistForm";
import RemoteActionBaqueiraSeasonForm from "../forms/RemoteActionBaqueiraSeasonForm";

class MatrixConstructor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      matrixModalOpen: false,
      matrixMatricula: "",
      currentView: "main",
      matrixSN: "",
      lockerType: "",
      blockType: null,
      blockedLockers: [],
      showButton: false, // Track button visibility
      buttonPosition: { x: 0, y: 0 }, // Track button position
      proModalOpen: false,
    };

    this.openMatrixDialog = this.openMatrixDialog.bind(this);
    this.closeMatrixDialog = this.closeMatrixDialog.bind(this);
    this.changeView = this.changeView.bind(this);
    this.updateBlockType = this.updateBlockType.bind(this);
    this.handleBlockedLocker = this.handleBlockedLocker.bind(this);
    this.handleRightClick = this.handleRightClick.bind(this);
    this.hideButton = this.hideButton.bind(this);
  }

  componentDidMount() {
    // Add a listener to handle page unload
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  }

  componentWillUnmount() {
    if (this.state.matrixSN !== "") {
      // Ensure blockType is set to false when the component unmounts
      //REVISAR this.props.blockOnlineSale(this.props.machine._id, false, this.state.matrixSN, this.state.matrixMatricula);
      // Remove the event listener
      window.removeEventListener("beforeunload", this.handleBeforeUnload);
    }
  }

  handleBeforeUnload = (event) => {
    if (this.state.matrixSN !== "") {
      // Set blockType to false on page unload
      //REVISAR this.props.blockOnlineSale(this.props.machine._id, false, this.state.matrixSN, this.state.matrixMatricula);

      // Optionally prevent the default behavior
      event.preventDefault();
      event.returnValue = "";
    }
  };

  openMatrixDialog(matricula, sn, type, block, e) {
    // GROUP customers are view-only on the matrix: they can see the locker
    // grid but cannot open the operate modal.
    if (this.props.role === "CUSTOMER" && this.props.type === "GROUP") {
      return;
    }
    this.setState(
      {
        matrixModalOpen: true,
        matrixMatricula: matricula,
        currentView: "main",
        matrixSN: sn,
        lockerType: type,
        blockType: block,
      },
      () => {
        // Call blockOnlineSale with blockType = true when the modal opens
        //REVISAR this.props.blockOnlineSale(this.props.machine._id, true, this.state.matrixSN, this.state.matrixMatricula);
      },
    );
  }

  closeMatrixDialog() {
    this.setState({ matrixModalOpen: false }, () => {
      // Call blockOnlineSale with blockType = false when the modal closes
      //REVISAR
      /*this.props.blockOnlineSale(this.props.machine._id, false, this.state.matrixSN, this.state.matrixMatricula)
        .then((response) => {
          this.setState({
            matrixMatricula: '',
            matrixSN: ''
          });
        })
        .catch((error) => {
          console.error('Error blocking locker:', error);
        });
        */
    });
  }

  changeView(view) {
    this.setState({ currentView: view });
  }

  updateBlockType(newBlockType) {
    this.setState({ blockType: newBlockType });
  }

  getErrorCode(error) {
    switch (error) {
      case "0x00":
        return "OK";
      case "0xFF":
        return "INITIALIZED";
      case "0x01":
        return "CONNECTED";
      case "0x02":
        return "ESP32 PROCESS SUCC";
      case "0x03":
        return "USER PIN ASSIGNED";
      case "0x04":
        return "CONN FAULT";
      case "0x05":
        return "SCAN TIMEOUT";
      case "0x06":
        return "GEN ERROR 1";
      case "0x07":
        return "ESP32 PROCESS UNSUCC";
      case "0x08":
        return "GEN ERROR 2";
      case "0x09":
        return "GEN ERROR 3";
      case "0x0A":
        return "GEN ERROR 4";
      case "0x0B":
        return "GEN ERROR 5";
      case "0x0C":
        return "USER PIN UNASSIGNED";
      default:
        return error;
    }
  }

  getColorClass(rssi) {
    if (rssi >= -60 && rssi !== 0) {
      return "HIGHTOP";
    } else if (rssi < -60 && rssi >= -65) {
      return "HIGH";
    } else if (rssi < -65 && rssi >= -70) {
      return "HIGHLOW";
    } else if (rssi < -70 && rssi >= -75) {
      return "MIDHIGH";
    } else if (rssi < -75 && rssi >= -80) {
      return "MID";
    } else if (rssi < -80 && rssi >= -85) {
      return "MIDLOW";
    } else if (rssi < -85 && rssi >= -90) {
      return "LOWHIGH";
    } else if (rssi < -90 && rssi >= -95) {
      return "LOW";
    } else if (rssi < -95 && rssi >= -100) {
      return "LOWTOP";
    } else {
      return "Null";
    }
  }

  infoMatrix() {
    const { currentView, blockType } = this.state;
    const { role, category, refreshMatrix, articles, type } = this.props;

    let checkMatricula = "";
    let checkBLEName = "";
    let checkHobbit = false;
    let checkBateria = "";
    let checkPin = "";
    let checkPhone = "";
    let checkName = "";
    let checkEmail = "";
    let checkModule = "";
    let checkPass = "";
    let checkAdmin = "";
    let checkType = "";
    let checkPosition = "";
    let checkStatus = "";
    let checkWide = "";
    let checkMode = "";
    let checkConfigured = false;
    let checkLastNightscan = "";
    let checkRssi = 0;
    let checkGender = "";
    let checkFaultCode = "";
    let checkErrorCode = "";
    let kerongVersion = "";
    let whitelistID = "";

    {
      this.props.matrixs.map((matrix) => {
        {
          matrix.Serial === this.props.machine.Serial &&
            matrix.Locker.map((lock, index) => {
              if (index + 1 == this.state.matrixMatricula) {
                checkMatricula = lock.Matricula || checkMatricula;
                checkType = lock.Type || checkType;
                checkBLEName = lock.BLEName || checkBLEName;
                checkBateria = lock.Bateria || checkBateria;
                checkPin = lock.Pin || checkPin;
                checkPhone = lock.Phone || checkPhone;
                checkEmail = lock.Email || checkEmail;
                checkName = lock.Name || checkName;
                checkModule = lock.ModuleSN || checkModule;
                checkPass = lock.Pass || checkPass;
                checkAdmin = lock.PasswordCash || checkAdmin;
                checkPosition = lock.Position || checkPosition;
                checkStatus = lock.Status || checkStatus;
                checkWide = lock.wide || checkWide;
                checkMode = lock.Mode || checkMode;
                checkConfigured = lock.Configured || checkConfigured;
                checkLastNightscan =
                  lock.LastNightScanCompleted || checkLastNightscan;
                checkRssi = lock.Rssi || checkRssi;
                checkGender = lock.Gender || checkGender;
                checkFaultCode = lock.FaultCode || checkFaultCode;
                checkErrorCode = lock.ErrorBle || checkErrorCode;
                kerongVersion = lock.KerongVersion || kerongVersion;
                whitelistID =
                  articles?.Whitelist?.find(
                    (item) => item._id === lock.BlockType,
                  )?.name || whitelistID;
              }
            });
        }
      });
    }

    const year = parseInt(checkLastNightscan.slice(0, 4));
    const month = parseInt(checkLastNightscan.slice(4, 6)) - 1; // month is zero-indexed
    const day = parseInt(checkLastNightscan.slice(6, 8));
    const hour = parseInt(checkLastNightscan.slice(8, 10));
    const minute = parseInt(checkLastNightscan.slice(10, 12));
    const second = parseInt(checkLastNightscan.slice(12, 14));

    const nightscanDate = new Date(year, month, day, hour, minute, second);

    nightscanDate.setHours(nightscanDate.getHours());
    const formattedDate = `${nightscanDate.getDate()}/${nightscanDate.getMonth() + 1}/${nightscanDate.getFullYear()}`;
    const formattedTime = `${nightscanDate.getHours().toString().padStart(2, "0")}:${nightscanDate.getMinutes().toString().padStart(2, "0")}`;

    const totalBattery = 6500; // Change this to the maximum battery value
    const minBattery = 4400; // Change this to the maximum battery value

    // Calculate the battery percentage
    const batteryPercentage =
      ((checkBateria - minBattery) / (totalBattery - minBattery)) * 100;

    // Determine the number of squares based on battery level
    let squaresCount;
    let batteryColor;

    squaresCount = 5;
    batteryColor = "green";

    // if (batteryPercentage >= 83.3) {
    //   squaresCount = 5;
    //   batteryColor = 'green';
    // } else if (batteryPercentage >= 66.7) {
    //   squaresCount = 4;
    //   batteryColor = 'green';
    // } else if (batteryPercentage >= 50) {
    //   squaresCount = 3;
    //   batteryColor = 'orange';
    // } else if (batteryPercentage >= 33.3) {
    //   squaresCount = 2;
    //   batteryColor = 'orange';
    // } else if (batteryPercentage >= 16.7) {
    //   squaresCount = 1;
    //   batteryColor = 'red';
    // } else {
    //   squaresCount = 0;
    //   batteryColor = 'red';
    // }

    if (currentView === "main") {
      return (
        <CSSTransition key="main" timeout={300} classNames="fade">
          <div>
            <div className="text-break text-monospace">
              <div className="row justify-content-center">
                <div className="col-xs-12 col-md-12 col-lg-4">
                  <Box
                    title="Pines"
                    icon="key"
                    bgcolor="vw-dark"
                    textcolor="white"
                  >
                    <PropertyLabel
                      name="Pin Cliente"
                      value={checkPass}
                      textcolor="white"
                    />
                    {type !== "PDA" && (
                      <PropertyLabel
                        name="Pin Universal"
                        value={checkAdmin}
                        textcolor="white"
                      />
                    )}
                  </Box>
                  <Box
                    title="Cliente"
                    icon="user"
                    bgcolor="vw-dark"
                    textcolor="white"
                  >
                    <PropertyLabel
                      name="Nombre"
                      value={checkName}
                      textcolor="white"
                    />
                    <PropertyLabel
                      name="Teléfono"
                      value={checkPhone}
                      textcolor="white"
                    />
                    <PropertyLabel
                      name="Email"
                      value={checkEmail}
                      textcolor="white"
                    />
                  </Box>
                  {role === "ADMIN" && (
                    <Box title="Potencia (Mejor a Peor)" icon="wifi">
                      <div className="rssi-bar">
                        {[
                          "HIGHTOP",
                          "HIGH",
                          "HIGHLOW",
                          "MIDHIGH",
                          "MID",
                          "MIDLOW",
                          "LOWHIGH",
                          "LOW",
                          "LOWTOP",
                        ].map((color) => (
                          <div
                            key={color}
                            id={`${color}`}
                            className={`rssi-square ${color === this.getColorClass(95) ? "highlighted" : ""}`}
                          >
                            {color === this.getColorClass(95) && <h5>{95}</h5>}
                          </div>
                        ))}
                      </div>
                    </Box>
                  )}
                  {role === "ADMIN" && (
                    <Box title="Bateria" icon="battery-full">
                      <div className="battery-indicator">
                        <div className="battery-info">
                          <div className="battery-percentage">{99.9} %</div>
                        </div>
                        <div className="battery-shape">
                          {Array.from({ length: squaresCount }, (_, index) => (
                            <div
                              key={index}
                              className={`battery-square ${batteryColor}`}
                            ></div>
                          ))}
                        </div>
                        <div className="battery-info">
                          <div className="battery-number">
                            {(5988 / 1000).toFixed(1)} V
                          </div>
                        </div>
                      </div>
                    </Box>
                  )}

                </div>
                {(role === "ADMIN" ||
                  (role === "CUSTOMER" &&
                    category === "BAQUEIRA" &&
                    this.props.machine.Contract.Zone !== 6)) && (
                  <div className="col-xs-12 col-md-12 col-lg-4">
                    <Box title="Reservas Baqueira" icon="hand-paper">
                      <div className="row">
                        <div className="col col-xs-12 col-md-12 col-lg-6">
                          <Button
                            color="primary"
                            className={`mt-2 mb-2 d-block w-100 ${blockType === null ? "btn-baqueira" : "btn-baqueira-blocked"}`}
                            onClick={() =>
                              blockType === null && this.changeView("baqueira1")
                            }
                            disabled={blockType !== null} // Optional: disable the button entirely based on blockType
                          >
                            <i className="fas fa-key d-block ml-auto mr-auto mb-2"></i>
                            RESERVA DIAS
                          </Button>
                        </div>
                        <div className="col col-xs-12 col-md-12 col-lg-6">
                          <Button
                            color="success"
                            className={`mt-2 mb-2 d-block w-100 ${blockType === null ? "btn-baqueira" : "btn-baqueira-blocked"}`}
                            onClick={() =>
                              blockType === null && this.changeView("baqueira2")
                            }
                            disabled={blockType !== null} // Optional: disable the button entirely based on blockType
                          >
                            <i className="fas fa-user-clock d-block ml-auto mr-auto mb-2"></i>
                            CLICK & COLLECT
                          </Button>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col col-xs-12 col-md-12 col-lg-6">
                          <Button
                            color="secondary"
                            className={`mt-2 mb-2 d-block w-100 ${blockType != null ? "btn-baqueira" : "btn-baqueira-blocked"}`}
                            onClick={() =>
                              blockType !== null && this.changeView("baqueira3")
                            }
                            disabled={blockType === null} // Optional: disable the button entirely based on blockType
                          >
                            <i className="fas fa-stop-circle d-block ml-auto mr-auto mb-2"></i>
                            RESERVA LISTA BLANCA
                          </Button>
                        </div>
                        <div className="col col-xs-12 col-md-12 col-lg-6">
                          <Button
                            color="info"
                            className={`mt-2 mb-2 d-block w-100 ${blockType === null ? "btn-baqueira" : "btn-baqueira-blocked"}`}
                            onClick={() =>
                              blockType === null && this.changeView("baqueira4")
                            }
                            disabled={blockType !== null} // Optional: disable the button entirely based on blockType
                          >
                            <i className="fas fa-calendar-alt d-block ml-auto mr-auto mb-2"></i>
                            RESERVA TEMPORADA
                          </Button>
                        </div>
                      </div>
                    </Box>
                    <Box title="Acciones Baqueira" icon="hand-paper">
                      <div className="row">
                        <div className="col col-xs-12 col-md-12 col-lg-6">
                          <Button
                            color="warning"
                            className="mt-2 mb-2 d-block w-100 btn-baqueira text-dark"
                            onClick={() => this.changeView("baqueira5")}
                          >
                            <i className="fas fa-ban d-block ml-auto mr-auto mb-2"></i>
                            BLOQUEO LISTAS BLANCAS
                          </Button>
                        </div>
                        <div className="col col-xs-12 col-md-12 col-lg-6">
                          <Button
                            color="dark"
                            className="mt-2 mb-2 d-block w-100 btn-baqueira"
                            onClick={() => this.changeView("baqueira6")}
                          >
                            <i className="fas fa-network-wired d-block ml-auto mr-auto mb-2"></i>
                            OTROS
                          </Button>
                        </div>
                      </div>
                    </Box>
                  </div>
                )}
                <div className="col-xs-12 col-md-12 col-lg-4">
                  <Box title="Acciones Remotas" icon="hand-paper">
                    <RemoteActionCustomerSingleAddForm
                      machine={this.props.machine}
                      lockerMatricula={this.state.matrixMatricula}
                      lockerStatus={checkStatus}
                      closeMatrixDialog={this.closeMatrixDialog}
                      onBeforeUnload={this.handleBeforeUnload}
                    />
                  </Box>
                  {(role === "ADMIN" || role === "CUSTOMER") && (
                    <Box title="Averias" icon="hand-paper">
                      {role === "CUSTOMER" && type === "LICENCIA_BASICA" ? (
                        <Button
                          color="secondary"
                          className="mt-2 mb-2 d-block w-100"
                          onClick={() =>
                            this.setState({ proModalOpen: true })
                          }
                        >
                          <i className="fas fa-lock d-block ml-auto mr-auto mb-2"></i>
                          {checkStatus !== "FL"
                            ? "MARCAR AVERÍA"
                            : "REPARAR AVERÍA"}
                          <span className="ml-2 badge badge-warning">
                            PRO
                          </span>
                        </Button>
                      ) : checkStatus === "FL" && role === "CUSTOMER" ? (
                        <Button
                          color="secondary"
                          className="mt-2 mb-2 d-block w-100"
                          disabled
                        >
                          <i className="fas fa-wrench d-block ml-auto mr-auto mb-2"></i>
                          REPARACIÓN PENDIENTE (SAT)
                        </Button>
                      ) : (
                        <Button
                          color={`${checkStatus !== "FL" ? "danger" : "success"}`}
                          className={`mt-2 mb-2 d-block w-100`}
                          onClick={() =>
                            this.changeView(
                              checkStatus !== "FL"
                                ? "faultView"
                                : "repairFaultView",
                            )
                          }
                        >
                          <i className="fas fa-times d-block ml-auto mr-auto mb-2"></i>
                          {checkStatus !== "FL"
                            ? "MARCAR AVERÍA"
                            : "REPARAR AVERÍA"}
                        </Button>
                      )}
                    </Box>
                  )}
                </div>
              </div>
            </div>
          </div>
        </CSSTransition>
      );
    }

    // View for "Acciones Baqueira 1" RESERVA POR DIAS
    if (currentView === "baqueira1") {
      return (
        <CSSTransition key="baqueira1" timeout={300} classNames="fade">
          <div className="row">
            <Button
              color="secondary"
              className="mb-3"
              onClick={() => this.changeView("main")}
            >
              Atrás
            </Button>
            <div className="col view-container slide-in">
              <Box title="Reserva de taquilla por días" icon="hand-paper">
                <RemoteActionBaqueiraRentDaysForm
                  lockerType={this.state.lockerType}
                  lockerSN={this.state.matrixSN}
                  machine={this.props.machine}
                  lockerMatricula={this.state.matrixMatricula}
                  lockerStatus={checkStatus}
                  closeMatrixDialog={this.closeMatrixDialog}
                />
              </Box>
            </div>
            <Button
              color="secondary"
              className="mb-3"
              onClick={() => this.changeView("main")}
            >
              Atrás
            </Button>
          </div>
        </CSSTransition>
      );
    }

    // View for "Acciones Baqueira 2" CLICK AND COLLECT
    if (currentView === "baqueira2") {
      return (
        <CSSTransition key="baqueira2" timeout={300} classNames="fade">
          <div className="row">
            <Button
              color="secondary"
              className="mb-3"
              onClick={() => this.changeView("main")}
            >
              Atrás
            </Button>
            <div className="col view-container slide-in">
              <Box title="Reserva Click & Collect" icon="hand-paper">
                <RemoteActionBaqueiraClickAndCollectForm
                  lockerType={this.state.lockerType}
                  lockerSN={this.state.matrixSN}
                  machine={this.props.machine}
                  lockerMatricula={this.state.matrixMatricula}
                  lockerStatus={checkStatus}
                  closeMatrixDialog={this.closeMatrixDialog}
                />
              </Box>
            </div>
            <Button
              color="secondary"
              className="mb-3"
              onClick={() => this.changeView("main")}
            >
              Atrás
            </Button>
          </div>
        </CSSTransition>
      );
    }

    // View for "Acciones Baqueira 3" RESERVA POR TEMPORADA
    if (currentView === "baqueira3") {
      return (
        <CSSTransition key="baqueira3" timeout={300} classNames="fade">
          <div className="row">
            <Button
              color="secondary"
              className="mb-3"
              onClick={() => this.changeView("main")}
            >
              Atrás
            </Button>
            <div className="col view-container slide-in">
              <Box title="Reserva de Lista Blanca" icon="hand-paper">
                <RemoteActionBaqueiraWhitelistForm
                  lockerType={this.state.lockerType}
                  lockerSN={this.state.matrixSN}
                  machine={this.props.machine}
                  lockerMatricula={this.state.matrixMatricula}
                  lockerStatus={checkStatus}
                  closeMatrixDialog={this.closeMatrixDialog}
                  whitelistName={whitelistID}
                />
              </Box>
            </div>
            <Button
              color="secondary"
              className="mb-3"
              onClick={() => this.changeView("main")}
            >
              Atrás
            </Button>
          </div>
        </CSSTransition>
      );
    }

    // View for "Acciones Baqueira 4" RESERVA TEMPORADA
    if (currentView === "baqueira4") {
      return (
        <CSSTransition key="baqueira4" timeout={300} classNames="fade">
          <div className="row">
            <Button
              color="secondary"
              className="mb-3"
              onClick={() => this.changeView("main")}
            >
              Atrás
            </Button>
            <div className="col view-container slide-in">
              <Box title="Reserva de temporada" icon="hand-paper">
                <RemoteActionBaqueiraSeasonForm
                  lockerType={this.state.lockerType}
                  lockerSN={this.state.matrixSN}
                  machine={this.props.machine}
                  lockerMatricula={this.state.matrixMatricula}
                  lockerStatus={checkStatus}
                  closeMatrixDialog={this.closeMatrixDialog}
                />
              </Box>
            </div>
            <Button
              color="secondary"
              className="mb-3"
              onClick={() => this.changeView("main")}
            >
              Atrás
            </Button>
          </div>
        </CSSTransition>
      );
    }

    // View for "Acciones Baqueira 5" BLOQUEO LISTA BLANCA
    if (currentView === "baqueira5") {
      return (
        <CSSTransition key="baqueira5" timeout={300} classNames="fade">
          <div className="row">
            <Button
              color="secondary"
              className="mb-3"
              onClick={() => this.changeView("main")}
            >
              Atrás
            </Button>
            <div className="col view-container slide-in">
              <Box title="Bloqueo de listas blancas" icon="hand-paper">
                {/* Replace with actual component or content for Acciones Baqueira 3 */}
                <RemoteActionBaqueiraBlockLockerForm
                  blockType={this.state.blockType}
                  lockerType={this.state.lockerType}
                  lockerSN={this.state.matrixSN}
                  machine={this.props.machine}
                  lockerMatricula={this.state.matrixMatricula}
                  lockerStatus={checkStatus}
                  closeMatrixDialog={this.closeMatrixDialog}
                  refreshMatrixData={refreshMatrix}
                  updateBlockType={this.updateBlockType}
                />
              </Box>
            </div>
            <Button
              color="secondary"
              className="mb-3"
              onClick={() => this.changeView("main")}
            >
              Atrás
            </Button>
          </div>
        </CSSTransition>
      );
    }

    // View for "Acciones Baqueira 6" OTROS
    if (currentView === "baqueira6") {
      return (
        <CSSTransition key="baqueira6" timeout={300} classNames="fade">
          <div className="row">
            <Button
              color="secondary"
              className="mb-3"
              onClick={() => this.changeView("main")}
            >
              Atrás
            </Button>
            <div className="col view-container slide-in">
              <Box title="Acciones Baqueira 6" icon="hand-paper">
                {/* Replace with actual component or content for Acciones Baqueira 3 */}
              </Box>
            </div>
            <Button
              color="secondary"
              className="mb-3"
              onClick={() => this.changeView("main")}
            >
              Atrás
            </Button>
          </div>
        </CSSTransition>
      );
    }

    if (currentView === "faultView") {
      return (
        <CSSTransition key="faultView" timeout={300} classNames="fade">
          <div className="row">
            <Button
              color="secondary"
              className="mb-3"
              onClick={() => this.changeView("main")}
            >
              Atrás
            </Button>
            <div className="col view-container slide-in">
              <Box title="Marcar avería en taquilla" icon="hand-paper">
                <RemoteActionFaultAddForm
                  lockerType={this.state.lockerType}
                  lockerSN={this.state.matrixSN}
                  machine={this.props.machine}
                  lockerMatricula={this.state.matrixMatricula}
                  closeMatrixDialog={this.closeMatrixDialog}
                  refreshMatrixData={refreshMatrix}
                />
              </Box>
            </div>
            <Button
              color="secondary"
              className="mb-3"
              onClick={() => this.changeView("main")}
            >
              Atrás
            </Button>
          </div>
        </CSSTransition>
      );
    }

    if (currentView === "repairFaultView") {
      return (
        <CSSTransition key="repairFaultView" timeout={300} classNames="fade">
          <div className="row">
            <Button
              color="secondary"
              className="mb-3"
              onClick={() => this.changeView("main")}
            >
              Atrás
            </Button>
            <div className="col view-container slide-in">
              <Box
                title="Marcar reparación de avería en taquilla"
                icon="hand-paper"
              >
                <RemoteActionFaultRepairForm
                  lockerType={this.state.lockerType}
                  lockerSN={this.state.matrixSN}
                  machine={this.props.machine}
                  lockerMatricula={this.state.matrixMatricula}
                  closeMatrixDialog={this.closeMatrixDialog}
                  refreshMatrixData={refreshMatrix}
                />
              </Box>
            </div>
            <Button
              color="secondary"
              className="mb-3"
              onClick={() => this.changeView("main")}
            >
              Atrás
            </Button>
          </div>
        </CSSTransition>
      );
    }
  }

  getBackgroundColor(BlockType) {
    const { articles } = this.props;

    // Ensure articles and articles.Whitelist exist before searching
    if (!articles || !articles.Whitelist) {
      return null;
    }

    // Find the whitelist item by its _id
    const whitelistItem = articles.Whitelist.find(
      (item) => item._id === BlockType,
    );

    // If the item is found, return its color; otherwise, return a default value or null
    return whitelistItem ? whitelistItem.color : null;
  }

  getBackgroundName(BlockType) {
    const { articles } = this.props;

    // Ensure articles and articles.Whitelist exist before searching
    if (!articles || !articles.Whitelist) {
      return null;
    }

    // Find the whitelist item by its _id
    const whitelistItem = articles.Whitelist.find(
      (item) => item._id === BlockType,
    );

    // If the item is found, return its color; otherwise, return a default value or null
    return whitelistItem ? whitelistItem.name : null;
  }

  handleBlockedLocker() {
    /*this.props.blockOnlineSale(this.props.machine._id, false, this.state.matrixSN, this.state.matrixMatricula)
      .then((response) => {
        if (this.props.refreshMatrix) {
          this.props.refreshMatrix();
        }
      })
      .catch((error) => {
        console.error('Error blocking locker:', error);
      });
      */
  }

  handleRightClick(e, lock) {
    const { role, type } = this.props;

    // GROUP customers are view-only — no context-menu action.
    if (role === "CUSTOMER" && type === "GROUP") {
      return;
    }

    if (lock.BackOfficeBlock && type !== "PDA") {
      e.preventDefault(); // Prevent default context menu

      const container = document.getElementById("matrixContainer");
      const containerRect = container.getBoundingClientRect();

      this.setState({
        matrixMatricula: lock.Matricula,
        matrixSN: lock.BLEName,
        showButton: true,
        buttonPosition: {
          x: e.clientX - containerRect.left, // Position relative to the container
          y: e.clientY - containerRect.top, // Position relative to the container
        },
      });
    }
  }

  hideButton() {
    this.setState({
      matrixMatricula: "",
      matrixSN: "",
      showButton: false,
    }); // Hide the button
  }

  render() {
    const { currentView, blockType, showButton, buttonPosition } = this.state;
    const { category, matrixs, blockedLockers, type } = this.props;

    const matrixRender = [];
    let lockerStatus = "";
    let matrixIndex = 0;
    let checkKiosc = 0;

    let columnHeight = 0;
    let matrixWidth = 0;

    {
      matrixs.map((matrix) => {
        {
          matrix.Serial === this.props.machine.Serial &&
            matrix.Locker.map((lock, index) => {
              if (matrixIndex < this.props.machine.LastIndex) {
                let lockerSelected = lock.Mode + lock.Wide + lock.Type;

                lock.Configured
                  ? (lockerStatus = lock.Status)
                  : (lockerStatus = "Null");

                //lock.Status == "FB" ? lockerStatus = "AV" : lockerStatus = lock.Status

                switch (lock.Type) {
                  case "S":
                    columnHeight += 45;
                    break;
                  case "M":
                    columnHeight += 90;
                    break;
                  case "L":
                    columnHeight += 135;
                    break;
                  case "XL":
                    columnHeight += 180;
                    break;
                  case "2XL":
                    columnHeight += 225;
                    break;
                  case "3XL":
                    columnHeight += 270;
                    break;
                }

                if (columnHeight >= 270) {
                  columnHeight = 0;

                  if (lock.Wide === "N") {
                    matrixWidth += 45;
                  } else {
                    matrixWidth += 60;
                  }
                }

                const isBlocked = blockedLockers.includes(lock.Matricula);

                matrixRender.push(
                  <div
                    key={index}
                    id={`locker${lockerSelected}`}
                    className={
                      isBlocked || lock.BackOfficeBlock ? "lockerBlocked" : ""
                    }
                    onClick={(e) => {
                      if (lock.BackOfficeBlock) {
                        // If BackOfficeBlock is true, do nothing to block the click
                        return;
                      }
                      // Otherwise, proceed with opening the matrix dialog
                      this.openMatrixDialog(
                        index + 1,
                        lock.BLEName,
                        lockerSelected,
                        lock.BlockType,
                        e,
                      );
                    }}
                    onContextMenu={(e) => this.handleRightClick(e, lock)}
                  >
                    <p>
                      {this.props.getRoomNumber
                        ? this.props.getRoomNumber(index)
                        : index + this.props.machine.FirstIndex}
                    </p>
                    <div id={lockerStatus}>
                      <p>{lockerStatus}</p>
                    </div>
                    {lock.BlockType !== null && lock.Type === "3XL" && (
                      <div
                        style={{
                          backgroundColor: this.getBackgroundColor(
                            lock.BlockType,
                          ),
                          writingMode: "vertical-rl", // Make the text vertical
                          paddingTop: "10px", // Optional padding for better visibility
                          paddingBottom: "10px", // Optional padding for better visibility
                          display: "inline-block", // Ensures the block shrinks to fit the text
                          height: "auto", // Ensures proper height adjustment
                          alignItems: "center", // Optional centering
                          justifyContent: "center", // Optional centering
                          fontSize: "small",
                          borderRadius: "10px",
                          border: "1px solid #ccc",
                        }}
                      >
                        <span>{this.getBackgroundName(lock.BlockType)}</span>
                      </div>
                    )}
                  </div>,
                );

                matrixIndex++;

                if (lock.Position === "C" && checkKiosc === 0) {
                  columnHeight += 135;

                  matrixRender.push(
                    <div key={matrixIndex} id="lockerKioskLeft"></div>,
                  );

                  checkKiosc = 1;
                } else if (lock.Position === "E" && checkKiosc === 0) {
                  columnHeight += 90;

                  matrixRender.push(
                    <div key={matrixIndex} id="lockerEcomKioskLeft"></div>,
                  );

                  checkKiosc = 1;
                } else if (lock.Position === "C" && checkKiosc === 1) {
                  columnHeight += 135;

                  matrixRender.push(
                    <div key={matrixIndex} id="lockerKioskRight"></div>,
                  );

                  checkKiosc = 0;
                } else if (lock.Position === "E" && checkKiosc === 1) {
                  columnHeight += 90;

                  matrixRender.push(
                    <div key={matrixIndex} id="lockerEcomKioskRight"></div>,
                  );

                  checkKiosc = 0;
                }
              }
            });
        }
      });
    }

    return (
      <>
        <div id="matrixContainer" style={{ width: matrixWidth + 40 }}>
          <div class="row" id="lockerMatrix">
            {matrixRender}
          </div>
          <div>
            <Modal
              isOpen={this.state.matrixModalOpen}
              toggle={this.closeMatrixDialog}
              backdrop={true}
              className="locker-modal"
            >
              <ModalHeader
                toggle={this.closeMatrixDialog}
                style={{ padding: 0, border: 'none' }}
              >
                <div style={{
                  padding: '24px 24px 20px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 10,
                  width: '100%',
                  background: '#ffffff',
                }}>
                  {/* Locker number badge — styled like a physical locker door */}
                  <div style={{
                    background: '#1e3a5f',
                    border: '3px solid #334155',
                    borderRadius: 14,
                    padding: '10px 28px',
                    boxShadow: 'inset 0 2px 6px rgba(0,0,0,0.35), 0 6px 18px rgba(15,23,42,0.18)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                    minWidth: 90,
                  }}>
                    <span style={{ color: 'rgba(148,163,184,0.7)', fontSize: 10, fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase' }}>Taquilla</span>
                    <span style={{ color: '#fff', fontSize: 42, fontWeight: 900, lineHeight: 1, letterSpacing: -1 }}>
                      {this.props.getRoomNumber
                        ? this.props.getRoomNumber(Number(this.state.matrixMatricula) - 1)
                        : Number(this.state.matrixMatricula) + this.props.machine.FirstIndex - 1}
                    </span>
                  </div>
                  {/* Machine name */}
                  <span style={{ color: '#64748b', fontSize: 12, fontWeight: 600, letterSpacing: 0.5 }}>
                    {this.props.machine && this.props.machine.Name}
                  </span>
                  {/* Block warning badge */}
                  {blockType != null && (
                    <div style={{
                      background: this.getBackgroundColor(blockType),
                      borderRadius: 6,
                      padding: '5px 14px',
                      fontSize: 12,
                      fontWeight: 700,
                      color: '#fff',
                      letterSpacing: 0.5,
                    }}>
                      <i className="fas fa-lock mr-2"></i>
                      Bloqueada para: {this.getBackgroundName(blockType)}
                    </div>
                  )}
                </div>
              </ModalHeader>
              <ModalBody>
                <TransitionGroup>{this.infoMatrix()}</TransitionGroup>
              </ModalBody>
            </Modal>
          </div>
          {showButton && (
            <div
              style={{
                position: "absolute",
                top: buttonPosition.y,
                left: buttonPosition.x,
                zIndex: 1000,
              }}
            >
              <Button
                color="primary"
                className={`btn-baqueira`}
                onClick={() => {
                  this.handleBlockedLocker(); // Handle blocked locker logic
                  this.hideButton(); // Hide button after action
                }}
              >
                <i className="fas fa-ban d-block ml-auto mr-auto mb-2"></i>
                Desbloquear taquilla
              </Button>
              <Button
                color="secondary"
                className={`btn-baqueira`}
                onClick={() => {
                  this.hideButton(); // Hide button after action
                }}
              >
                <i className="fas fa-times d-block ml-auto mr-auto mb-2"></i>
                Cancelar
              </Button>
            </div>
          )}
        </div>

        {/* Pro upgrade modal for LICENCIA_BASICA customers */}
        <Modal
          isOpen={this.state.proModalOpen}
          toggle={() => {
            this.setState({ proModalOpen: false });
            this.props.resetProUpgrade();
          }}
          centered
        >
          <ModalHeader
            toggle={() => {
              this.setState({ proModalOpen: false });
              this.props.resetProUpgrade();
            }}
          >
            <i className="fas fa-star mr-2" style={{ color: "#f59e0b" }}></i>
            Función exclusiva de Licencia{" "}
            <span style={{ color: "#f59e0b" }}>PRO</span>
          </ModalHeader>
          <ModalBody>
            {this.props.proUpgradeSent ? (
              <div className="text-center py-3">
                <i
                  className="fas fa-check-circle fa-3x mb-3"
                  style={{ color: "#10b981" }}
                ></i>
                <h5>¡Solicitud enviada!</h5>
                <p className="text-muted">
                  Nuestro equipo se pondrá en contacto contigo para gestionar la
                  actualización a PRO.
                </p>
              </div>
            ) : (
              <>
                <p>
                  La gestión de averías en taquillas desde el panel de cliente
                  es una función exclusiva de la <strong>Licencia PRO</strong>.
                </p>
                <p className="text-muted" style={{ fontSize: 13 }}>
                  Actualiza tu licencia para marcar y reparar averías
                  directamente desde aquí.
                </p>
                {this.props.proUpgradeError && (
                  <p className="text-danger" style={{ fontSize: 12 }}>
                    No se pudo enviar la solicitud. Inténtalo de nuevo más
                    tarde.
                  </p>
                )}
              </>
            )}
          </ModalBody>
          {!this.props.proUpgradeSent && (
            <ModalFooter>
              <Button
                color="secondary"
                onClick={() => {
                  this.setState({ proModalOpen: false });
                  this.props.resetProUpgrade();
                }}
              >
                Cerrar
              </Button>
              <Button
                color="warning"
                onClick={() => this.props.requestProUpgrade()}
                disabled={this.props.proUpgradeLoading}
              >
                {this.props.proUpgradeLoading ? (
                  <span>
                    <i className="fas fa-spinner fa-spin mr-2"></i>Enviando...
                  </span>
                ) : (
                  <span>
                    <i className="fas fa-star mr-2"></i>Solicitar actualización
                    a PRO
                  </span>
                )}
              </Button>
            </ModalFooter>
          )}
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  role: state.auth.role,
  type: state.auth.type,
  fullname: state.auth.fullname,
  category: state.auth.category,
  proUpgradeLoading: state.license.loading,
  proUpgradeSent: state.license.sent,
  proUpgradeError: state.license.error,
});

const mapDispatchToProps = (dispatch) => ({
  blockOnlineSale: bindActionCreators(blockOnlineSale, dispatch),
  requestProUpgrade: bindActionCreators(requestProUpgrade, dispatch),
  resetProUpgrade: bindActionCreators(resetProUpgrade, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MatrixConstructor);
